// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper_Wrapper__1aObx","center":"Wrapper_center__6cSIk","List":"Wrapper_List__2hS7U","horizontal":"Wrapper_horizontal__1rvon"};